import React from 'react'
import '../components/Styles/home.css'
import '../components/Styles/About.css'
import '../components/Styles/contact.css'
import {Helmet}from"react-helmet";
import { PopupButton } from "react-calendly";
import xm1 from '../assets/images/contact.png'
import mem1 from '../assets/images/tmember.png'
import c1 from '../assets/images/c1.png'
import c2 from '../assets/images/c2.png'
import c3 from '../assets/images/c3.png'
import c4 from '../assets/images/c4.png'
import c5 from '../assets/images/c5.png'
import c6 from '../assets/images/c6.png'
import c7 from '../assets/images/c7.png'

const Privacy = () => {
  const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3v3M17 3v3M4.5 8.5h15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8 12h3M8 15h3M14 12h2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* renamed to avoid conflict with IconPhone above */
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);
  return (
    <div>
              <Helmet>
      
      <title>Privacy Policy – Xceed Office</title>
      <meta name="description" content="Read Xceed Office's Privacy Policy to learn how we collect, use, store, and protect your personal information when you visit our website or use our services."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>

 <section className="conversation">
  <div className="conversation__container" >

  <div
  style={{
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 18px",
    border: "1px solid #b38b12",
    color: "#d4af37",
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    background: "transparent",
    fontFamily: "Arial, sans-serif",
  }}
>
  LEGAL
</div>
   
    <h2 className="conversation__title">
    Privacy  <span>Policy</span>
    </h2>

    <p className="conversation__text">
    Effective date: July 15, 2026
    </p>

  </div>
</section>
<section className="privacy-section">
      <div className="privacy-container">
        <p className="privacy-intro">
          Xceed Office respects your privacy. This Privacy Policy explains how
          we collect, use and protect information submitted through our
          website, advertising forms and other business communications.
        </p>

        <h2>Information We Collect</h2>

        <p className="privacy-text">
          We may collect information including:
        </p>

        <ul className="privacy-list">
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Company name</li>
          <li>Office-space requirements</li>
          <li>Preferred move-in date</li>
          <li>Estimated office budget</li>
          <li>Tour preferences</li>
          <li>Messages or other information submitted to us</li>
        </ul>

        <p className="privacy-note">
          We may also collect basic website usage information through cookies,
          analytics tools and advertising platforms.
        </p>

        <br />            {/* How We Use Your Information */}
    <h2>How We Use Your Information</h2>

<p className="privacy-text">
  We may use your information to:
</p>

<ul className="privacy-list">
  <li>Respond to inquiries</li>
  <li>Provide office availability and pricing</li>
  <li>Arrange private office tours</li>
  <li>Communicate about Xceed Office services</li>
  <li>Manage memberships, bookings and customer relationships</li>
  <li>Improve our website, advertising and customer experience</li>
  <li>Prevent fraud and protect our business</li>
  <li>Comply with applicable legal requirements</li>
</ul>
<br />
{/* How We Share Information */}
<h2 className="privacy-heading-space">How We Share Information</h2>

<p className="privacy-note">
  We may share information with service providers that help us operate our
  business, including website hosting, email, customer-management,
  booking, payment, analytics and advertising providers.
</p>
<br />
<p className="privacy-note">
  We do not sell personal information. We may disclose information when
  required by law or when necessary to protect our legal rights.
</p>
<br />
{/* Advertising Platforms */}
<h2 className="privacy-heading-space">Advertising Platforms</h2>

<p className="privacy-note">
  When you submit information through Facebook, Instagram or another
  advertising platform, the platform may also process your information
  according to its own privacy policies and terms.
</p>
<br />
{/* Data Retention */}
<h2 className="privacy-heading-space">Data Retention</h2>

<p className="privacy-note">
  We retain personal information only for as long as reasonably necessary
  to respond to inquiries, provide services, maintain business records and
  meet legal obligations.
</p>
<br />
<h2>Your Choices</h2>

<p className="privacy-note">
  You may request that we update or delete your information, or ask us to
  stop sending marketing communications, by contacting us.
</p>
<br />
{/* Security */}
<h2 className="privacy-heading-space">Security</h2>

<p className="privacy-note">
  We use reasonable administrative and technical measures to protect
  personal information. However, no online system can guarantee complete
  security.
</p>
<br />
{/* Changes to This Policy */}
<h2 className="privacy-heading-space">Changes to This Policy</h2>

<p className="privacy-note">
  We may update this Privacy Policy periodically. Updated versions will be
  posted on this page with a revised effective date.
</p>
      </div>
    </section>


    </div>
  )
}

export default Privacy